import { jsxs as h, jsx as o } from "react/jsx-runtime";
import { c as $ } from "react/compiler-runtime";
import { useTheme as q, useMediaQuery as J, Button as V, IconButton as X } from "@mui/material";
import { AppBar as Y } from "../../atoms/AppBar/AppBar.js";
import { Avatar as Z } from "../../atoms/Avatar/Avatar.js";
import "react";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../../molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../../molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import tt from "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import "../../atoms/Box/Box.js";
import { Grid as g } from "../../atoms/Grid/Grid.js";
import { Typography as C } from "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "../SunburstGraph/SunburstGraph.js";
import "../RadarGraph/RadarGraph.js";
import "../ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "../ReactMap/index.js";
import "@mui/material/Button";
import "../ReactMap/GMapStatic.js";
import "../../../chunks/index.esm.js";
import "@mui/icons-material/Clear";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import { Toolbar as it } from "../../atoms/Toolbar/Toolbar.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/material/Typography";
import ot from "@mui/icons-material/Menu";
function Yo(x) {
  const t = $(38), {
    children: F,
    subtitle: B,
    title: I,
    userName: u,
    profilePicture: S,
    role: T,
    profileCard: A,
    showAvatar: R,
    setAnchorEl: W,
    type: G,
    style: k,
    isMobile: H,
    onMobileSideDrawerOpen: N
  } = x, M = R === void 0 ? !0 : R, j = W === void 0 ? pt : W, _ = G === void 0 ? "primary" : G, K = H === void 0 ? !1 : H, z = N === void 0 ? rt : N, D = q();
  let y;
  t[0] !== D.breakpoints ? (y = D.breakpoints.down("sm"), t[0] = D.breakpoints, t[1] = y) : y = t[1];
  const P = J(y), i = K || P;
  let b;
  t[2] !== j ? (b = (v) => {
    j(v.currentTarget);
  }, t[2] = j, t[3] = b) : b = t[3];
  const E = b, L = et[_];
  let p;
  t[4] !== k ? (p = k || {}, t[4] = k, t[5] = p) : p = t[5];
  let e;
  t[6] !== L.appBar || t[7] !== p ? (e = [r.appBar, L.appBar, p], t[6] = L.appBar, t[7] = p, t[8] = e) : e = t[8];
  let m;
  t[9] !== i || t[10] !== z ? (m = i && /* @__PURE__ */ o(X, { sx: {
    p: 0
  }, onClick: z, children: /* @__PURE__ */ o(ot, {}) }), t[9] = i, t[10] = z, t[11] = m) : m = t[11];
  let n;
  t[12] !== I ? (n = /* @__PURE__ */ o(C, { type: "heading1", sx: r.title, children: I }), t[12] = I, t[13] = n) : n = t[13];
  let s;
  t[14] !== i || t[15] !== B ? (s = !i && /* @__PURE__ */ o(C, { type: "heading2", color: "#747982", children: B }), t[14] = i, t[15] = B, t[16] = s) : s = t[16];
  let a;
  t[17] !== m || t[18] !== n || t[19] !== s ? (a = /* @__PURE__ */ o(g, { sx: r.headings, children: /* @__PURE__ */ o(g, { sx: r.container, children: /* @__PURE__ */ h(g, { container: !0, alignItems: "center", sx: r.titleContainer, children: [
    m,
    n,
    s
  ] }) }) }), t[17] = m, t[18] = n, t[19] = s, t[20] = a) : a = t[20];
  let l;
  t[21] !== F || t[22] !== a ? (l = /* @__PURE__ */ h(g, { container: !0, sx: r.leftContainer, children: [
    a,
    F
  ] }), t[21] = F, t[22] = a, t[23] = l) : l = t[23];
  let c;
  t[24] !== E || t[25] !== i || t[26] !== S || t[27] !== T || t[28] !== M || t[29] !== u ? (c = M && /* @__PURE__ */ h(V, { variant: "text", sx: r.user(i), endIcon: i ? void 0 : /* @__PURE__ */ o(tt, { color: "disabled", style: {
    fontSize: "16px"
  } }), onClick: E, children: [
    (() => {
      const v = (u || "").trim();
      let O = "?";
      if (v) {
        const f = v.split(/\s+/), U = f[0]?.[0] || "", Q = f.length > 1 ? f[f.length - 1]?.[0] || "" : f[0]?.[1] || "";
        O = (U + Q).toUpperCase() || (U || "?").toUpperCase();
      }
      return /* @__PURE__ */ o(Z, { src: S || void 0, width: i ? 20 : 32, height: i ? 20 : 32, sx: {
        color: "white",
        bgcolor: "#878787",
        fontSize: i ? 10 : 12,
        fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 600,
        letterSpacing: 0.2
      }, children: O });
    })(),
    !i && /* @__PURE__ */ h(g, { container: !0, flexDirection: "column", alignItems: "start", children: [
      /* @__PURE__ */ o(C, { type: "bodyText2", sx: r.avatarText, children: u }),
      /* @__PURE__ */ o(C, { type: "bodyText3", sx: r.avatarText, children: T })
    ] })
  ] }), t[24] = E, t[25] = i, t[26] = S, t[27] = T, t[28] = M, t[29] = u, t[30] = c) : c = t[30];
  let d;
  t[31] !== A || t[32] !== l || t[33] !== c ? (d = /* @__PURE__ */ h(it, { sx: r.toolBar, children: [
    l,
    c,
    A
  ] }), t[31] = A, t[32] = l, t[33] = c, t[34] = d) : d = t[34];
  let w;
  return t[35] !== e || t[36] !== d ? (w = /* @__PURE__ */ o(Y, { position: "static", sx: e, children: d }), t[35] = e, t[36] = d, t[37] = w) : w = t[37], w;
}
function rt() {
  return null;
}
function pt() {
  return null;
}
const r = {
  appBar: () => ({
    zIndex: 1201,
    width: "100%",
    justifyContent: "center",
    paddingLeft: 0,
    borderRadius: {
      xs: "0",
      sm: "16px 0 0 0"
    },
    height: {
      xs: "48px",
      sm: "56px"
    }
  }),
  container: () => ({
    gap: {
      xs: "4px",
      sm: "8px"
    },
    paddingLeft: {
      xs: "8px",
      sm: "16px"
    }
  }),
  leftContainer: {
    gap: {
      xs: "4px",
      sm: "8px"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  logo: () => ({
    fontSize: "1.5rem",
    padding: "10px 14px",
    display: "flex",
    alignItems: "center"
  }),
  toolBar: {
    minHeight: "0 !important",
    height: "100%",
    gap: {
      xs: "4px",
      sm: "8px",
      md: "16px"
    },
    padding: "0 !important",
    width: "100%",
    justifyContent: "space-between"
  },
  titleContainer: {
    alignItems: "center",
    gap: {
      xs: "4px",
      sm: "8px"
    }
  },
  title: {
    fontSize: {
      xs: "14px",
      sm: "16px"
    },
    fontWeight: "600",
    color: "#226A58"
  },
  user: (x) => ({
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: x ? "4px" : "8px",
    background: "#FFFFFF",
    height: "100%",
    padding: x ? "0 8px" : "0 24px",
    textTransform: "unset",
    borderRadius: 0,
    borderLeft: "1px solid #EFEFEF",
    minWidth: x ? "auto" : "fit-content"
    // do not force Avatar background so consumers can control avatar colors
  }),
  headings: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  avatarText: {
    color: "#878787",
    letterSpacing: "0.23px"
  }
}, et = {
  primary: {
    appBar: {
      backgroundColor: "#FFFFFF",
      boxShadow: "none"
    }
  },
  secondary: {
    appBar: {}
  }
};
export {
  Yo as TopBar
};
